module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Images",
      "src": "images/head.jpg"
    }
  }), _vm._v(" “Fame” at Shiloh")]), _vm._v(" "), _c('h3', {
    staticClass: "ch_aut",
    attrs: {
      "id": "aut3"
    }
  }, [_vm._v("by Chris Mackowski")]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Originally published as a blog post at Emerging Civil War on April 10, 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think of her standing there, right arm outstretched, pen in hand, the tip not quite daring to touch the granite obelisk. Her left hand hangs back behind her, her fingers poised daintily, helping her balance. She is “Fame,” twelve and a half feet tall and bronze, and she has inscribed the name of Iowa on the Shiloh battlefield."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#A1",
      "id": "B1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She leans toward the monument, her right pinky daintily extended, her hand poised to write, but it looks as though her work is already done. The inscription above her pen, written in script, reads:")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Brave of the brave, the twice five thousand men")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Who all that day stood in the battle’s shock,")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fame holds them dear, and with immortal pen")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Inscribes their names on the enduring rock.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("I first saw Fame in 2006 during a March visit to the battlefield. From the car window, I caught her from the corner of my eye, slipping up the side "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("platforms of the granite monument. I stopped the car, looked closer. She was reaching out, ready to write, ready to inscribe immortal words on Iowa’s behalf. I got out for a closer look. I knew not who this Muse was, but part of me loved her already.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As it turns out, the real-life inspiration for the figure was Santina Grosse Trieble, wife and muse of the statue’s sculptor, Frederick “Fritz” Trieble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The monument, dedicated in November of 1906 at a cost of twenty-five thousand dollars, stands near the battlefield visitor center. The Santina-inspired figure of Fame ascends a stepped pedestal toward the monument. A column rises from its body, topped by an eagle perched on a small globe. In all, the monument stands seventy-five feet tall. The eagle, with its 15-foot wingspan, serves as an icon for the park, but its the bronze muse at the statue’s base that captivates me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eleven Iowa units took part in the battle: the 2nd, 3rd, 6th, 7th, 8th, 11th, 12th, 13th, 14th, 15th and 16th—more than 6,660 soldiers, 2,400 of whom ended up as casualties. Many of them held the center of the infamous Hornet’s Nest, facing withering fire and constant onslaught. All eleven regiments have individual monuments on the battlefield.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think of the impressive Iowa monument at Vicksburg, dedicated the same year as this monument at Shiloh. Much more elaborate, construction cost four times as much and took until 1912. A bronze equestrian statue stands as its centerpiece and six bronze bas-relief tablets depicts various actions of the Vicksburg campaign in which Iowans played important roles. The monument is splendid in its grandeur, rivaling anything I’ve seen on any other battlefield.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think, too, of Iowa’s other monuments, more modest but all including alert sentinels keeping dutiful watch over battlefields like Lookout Mountain and Missionary Ridge. In the national cemetery at Andersonville, a woman much like Fame kneels atop a monument, her head resting in grief in her right hand: “Iowa crying for the sons she has lost.” Two hundred fourteen Iowans died in the prison."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#A2",
      "id": "B2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To me, Fame represents the perfect manifestation of my own Civil War Muse, remembering Civil War stories. She’s so graceful as she writes, so ephemeral.")]), _vm._v(" "), _c('p', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#B1",
      "id": "A1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.nps.gov/parkhistory/online_books/hh/10/hh10f.htm",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.nps.gov/parkhistory/online_books/hh/10/hh10f.htm")])])])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#B2",
      "id": "A2"
    }
  }, [_vm._v("2")]), _vm._v("   “Iowa Monument at Andersonville,” Iowa Civil War "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://Monuments.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Monuments.com")])])]), _vm._v(": "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.iowacivilwarmonuments.com/cgi-bin/gaarddetails.pl?1217026119",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("http://www.iowacivilwarmonuments.com/cgi-bin/gaarddetails.pl?1217026119")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b853314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter2.vue
// module id = 90
// module chunks = 0